export default __webpack_public_path__ + "static/media/pers1.28a5387d.jpg";